import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAppStore } from "@/stores/RootStore";
import { Separator } from "@/ui/Separator";
import { Header } from "@/components/Header";
import { Device } from "@/types/types";
import { useFetch } from "@/hooks/useFetch";
import Spinner from "@/ui/Spinner/Spinner";

import DevicesGrid from "./DevicesGrid";
import { DateTime } from "luxon";
import _ from "lodash";

export const AdminDevices = () => {
  let { id } = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const currentSite = useAppStore().currentSite;

  const [loading, setLoading] = useState(true);

  const [{ response, isLoading, error }, doFetchItem] = useFetch(
    `/administration/devices/devices`,
    true,
  );
  const [devices, setDevices] = useState<Device[]>();

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) {
      return;
    }
    setDevices(response.data as unknown as Device[]);
    setLoading(false);
  }, [response]);

  let nodes = devices?.map((data) => {
    return {
      id: data.id,
      serial_number: data.attributes.serial_number,
      name: data.attributes.name,
      model: data.attributes.model,
      initialized_at: data.attributes.initialized_at
        ? DateTime.fromISO(data.attributes.initialized_at)
        : null,
      slots_count: data.attributes.slots_count,
      sensor_types: data.attributes.sensor_types
        ? data.attributes.sensor_types.map((item) => item.data_key_name)
        : null,
      online: data.attributes.online,
      site_id: data.attributes.site_id,
      site_name: data.attributes.site_name,
      receive_data: data.attributes.receive_data,
      electricity_meter: data.attributes.electricity_meter,
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  function empty() {}

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}>
            <span className="font-medium">
              {currentSite?.name ? currentSite?.name : "..."}
            </span>
          </NavLink>
          <span>/</span>
          <NavLink to={"/admin"}>
            <span className="font-medium">{t("admin")}</span>
          </NavLink>
          <span>/</span>
          {location.pathname == "/admin/devices/" ||
          location.pathname == "/admin/devices" ? (
            <span>{t("devices")}</span>
          ) : (
            <NavLink to={"/admin/devices"}>
              <span>{t("devices")}</span>
            </NavLink>
          )}
          {(id || location.pathname == "/admin/devices/new") && <span>/</span>}
          {id && (
            <span>
              {devices?.find((n) => n.id == id)?.attributes.serial_number}
            </span>
          )}
          {location.pathname == "/admin/devices/new" && (
            <span>{t("adding_device")}</span>
          )}
        </div>
      </div>
      <Separator className="flex-none" />
      {id || location.pathname == "/admin/devices/new" ? (
        <Outlet context={[devices, setDevices]} />
      ) : (
        <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
          <Header
            name={t("devices")}
            backName={t("admin")}
            backLink={"/admin"}
          />
          {loading ? (
            <Spinner />
          ) : (
            <DevicesGrid data={data!} setDevices={setDevices} onClose={empty} />
          )}
        </div>
      )}
    </div>
  );
};
